(function()
{
	var Debug = include('springroll.Debug');
	var Application = include('springroll.Application');
	var DebugOptions = include('nature.DebugOptions');
	var DelayedCall = include('springroll.DelayedCall');
	var Ease = include('createjs.Ease');
	var Enum = include('springroll.Enum');
	var RandomList = include('springroll.RandomList');
	var Task = include('nature.enum.Task');
	var Tween = include('createjs.Tween');

	var APPRX_LEAF_SEGMENT_TIME = 5000;
	var APPRX_GUST_SEGMENT_TIME = 5000;

	var _collideVOList = new RandomList([
		// VO: keep trying...
		'Daisy_Tutorial_L38',
		// VO: whoops
		'Daisy_Tutorial_L39',
		// try to fly without hitting any obstacles
		'Daisy_Tutorial_L37'
	]);

	var _app;
	var _arrow;
	var _clickNatureCatDC;
	var _currTaskTimer = 0;
	var _groundWarningIcon;
	var _groundWarningIconDC;
	var _panel;
	var _screenCenter = {};
	var _skipButton;
	var _state;
	var _task;
	var _tutorialConfig = {};

	/**
	 * The tutorial manager
	 * @class Tutorial
	 * @constructor
	 * @param {nature.GamePanel} state
	 */
	var Tutorial = function(state)
	{
		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		_app = Application.instance;

		/**
		 * The state running this tutorial
		 * @property {nature.GameState} state
		 */
		_state = state;

		/**
		 * Reference to the game panel
		 * @property {nature.GamePanel} panel
		 */
		_panel = state.panel;

		/**
		 * Reference to the skipButton
		 * @property {PIXI.Button} _skipButton
		 */
		_skipButton = _panel.skipButton;

		/**
		 * The property task
		 * @property {String} task
		 */
		_task = null;

		/**
		 * The tutorial configuration
		 * @property {Object} config
		 */
		_tutorialConfig = _app.config.tutorial;

		/**
		 * The tutorial configuration
		 * @property {Object} config
		 */
		_arrow = mixin(new pixiflash_lib.Arrow(), nature.Arrow);
		_panel.uiContainer.addChild(_arrow);

		// Bound functions
		this.endTutorial = this.endTutorial.bind(this);
		this.nextTask = this.nextTask.bind(this);
		this.onHeightWarning = this.onHeightWarning.bind(this);
		this.onCollide = this.onCollide.bind(this);
		this.onMeterPaused = this.onMeterPaused.bind(this);
		this.skip = this.skip.bind(this);

		if (DebugOptions.clearTutorial)
		{
			DebugOptions.clearTutorial = false;
			_app.userData.remove(COOKIE_NAME);
			_app.isTutorial = true;
		}

		if (DebugOptions.skipTut)
		{
			_app.isTutorial = false;
		}

		if (DebugOptions.tutorial)
		{
			_app.isTutorial = true;
		}
	};

	// Reference to prototype
	var p = Tutorial.prototype;

	/**
	 * The cookie name
	 * @property {String} COOKIE_NAME
	 * @static
	 */
	var COOKIE_NAME = Tutorial.COOKIE_NAME = 'didTutorial';

	/**
	 * Access the static private _task variable, only called once
	 */
	p.getTask = function()
	{
		return _task;
	};

	/**
	 * Start blowing
	 * @method startBlowPhase
	 */
	p.startBlowPhase = function()
	{
		if (!_app.isTutorial) return;

		_task = Task.WaitForTop;
		_panel.breathMeter.disable();

		// Fade out all current non-VO sounds
		var fadeOutsForInstruction = _app.config.tutorial.fadeOutsForInstruction;
		var sound = _app.sound;
		for (var i = 0, len = fadeOutsForInstruction.length; i < len; i++)
		{
			var item = fadeOutsForInstruction[i];
			sound.fadeOut(item.id, item.time, item.volume);
		}
		_skipButton.visible = true;
		_skipButton.once('buttonPress', this.skip);
		_app.voPlayer.play([
			_app.config.tutorial.fadeOutsForInstructionWait,
			'Daisy_Tutorial_L1',
			200,
			'Daisy_Tutorial_L2',
			300,
			'Daisy_Tutorial_L3',
			_arrow.show.bind(_arrow, 'meter'),
			300,
			'Daisy_Tutorial_L4',
			_arrow.show.bind(_arrow, false),
			function()
			{
				// Tutorial when it pauses at the top, then we'll stop the animation
				_panel.breathMeter.once('paused', this.onMeterPaused);
				_panel.breathMeter.pauseAtTopAndEnable();
				_task = Task.Breath;
			}.bind(this)
		]);
	};

	p.onMeterPaused = function()
	{
		_app.sound.pause('Anemometer');
		_app.sound.pause('WindSockBlowing');

		_arrow.show('naturecat');

		_app.voPlayer.play([
			'Daisy_Tutorial_L5',
			_app.hasTouch ? 'Daisy_Tutorial_L8' : 'Daisy_Tutorial_L6',
			// start delay call after VO completes
			function()
			{
				_clickNatureCatDC = new DelayedCall(function()
				{
					_app.voPlayer.play(_app.hasTouch ?
						'Daisy_Tutorial_L12' :
						'Daisy_Tutorial_L11');
				}.bind(this), 8000,
				{
					repeat: true
				});
			}.bind(this)
		]);
	};

	var _stopDelayedCalls = function()
	{
		if (_clickNatureCatDC)
			_clickNatureCatDC.destroy();
		if (_groundWarningIconDC)
			_groundWarningIconDC.destroy();
	};

	p.startGameplayPhase = function()
	{
		// Always attempt to destroy that pesky click VO reminder, even when tutorial is not enabled (user could click the skipbutton)
		_stopDelayedCalls();
		if (!_app.isTutorial) return;
		// Awesome! Here we go
		if (!DebugOptions.skipLaunch)
		{
			_app.voPlayer.play('Daisy_Tutorial_L13');
		}
	};

	p.startFlyingTutorial = function()
	{
		// Always attempt to destroy that pesky click VO reminder, even when tutorial is not enabled (user could click the skipbutton)
		_stopDelayedCalls();
		if (!_app.isTutorial) return;

		_task = Task.Fly;

		// Second call to check on the skip button because it disappears during certain testing options
		if (!_skipButton || _skipButton.visible === false)
		{
			_skipButton.visible = true;
			_skipButton.once('buttonPress', this.skip);
		}

		_panel.hud.show(false);
		_panel.seedContainer.lockY = true;
		_app.voPlayer.play([
			// VO: these are your seeds, let me show you how to fly them'
			_arrow.show.bind(_arrow, 'seeds'),
			'Daisy_Tutorial_L14',

			_arrow.show.bind(_arrow, 'down'),
			this.tweenSeedContainer.bind(this, 550, 3000),
			// Seeds will fall down on their own'
			'Daisy_Tutorial_L16',
			_arrow.show.bind(_arrow, false),
			250,

			// VO: Watch out, wheen your seeds hit the ground.. it's over!
			this.showGroundWarningIcon.bind(this, true),
			'Daisy_Tutorial_L20',
			this.showGroundWarningIcon.bind(this, false),
			250,

			// VO clicking will cause the seeds to float upwards
			_arrow.show.bind(_arrow, 'up'),
			this.tweenSeedContainer.bind(this, 150, 3000),
			_app.hasTouch ? 'Daisy_Tutorial_L24' : 'Daisy_Tutorial_L23',
			_arrow.show.bind(_arrow, false),
			1000,

			// VO: got it? now you try'
			'Daisy_Tutorial_L26',
			// tween back to center
			this.tweenSeedContainer.bind(this, 200, 1000),
			_state.startControlCountdown.bind(_state)
		]);
	};

	p.onHeightWarning = function()
	{
		_panel.seedContainer.off('heightWarning', this.onHeightWarning);
		if (_task == Task.Fly)
		{
			_currTaskTimer += _tutorialConfig.groundWarningPenaltyTime;
			// VO: Dont fly to low
			_app.voPlayer.play('Daisy_Tutorial_L34');
		}

		// ~szk: Keep showing the ground warning icon even during other tasks.
		// The player can't die in the tutorial, but showing them they are
		// flying low is still good to do (?)
		this.showGroundWarningIcon(true);
		_groundWarningIconDC = new DelayedCall(this.showGroundWarningIcon.bind(this, false), 2000);
	};

	p.tweenSeedContainer = function(y, time)
	{
		Tween.get(_panel.seedContainer).to(
		{
			y: y
		}, time, Ease.cubicInOut);
	};

	p.showGroundWarningIcon = function(show)
	{
		if (show || show === undefined)
		{
			if (!_groundWarningIcon)
			{
				_groundWarningIcon = new pixiflash_lib.WarningCircle();
				// If control countdown is overriden in the config/ui/groundWarningIcon.json
				var pos = _app.config.ui.groundWarningIcon;
				if (pos)
				{
					var groundWarningIcon = _groundWarningIcon;
					groundWarningIcon.x = pos.x || groundWarningIcon.x;
					groundWarningIcon.y = pos.y || groundWarningIcon.y;
					groundWarningIcon.scaleX = pos.scale || groundWarningIcon.scaleX;
					groundWarningIcon.scaleY = pos.scale || groundWarningIcon.scaleY;
				}
			}
			_panel.uiContainer.addChild(_groundWarningIcon);
		}
		else
		{
			//	_panel.uiContainer.removeChild(_groundWarningIcon);
		}
	};

	p.launch = function()
	{
		_task = null;
		_arrow.show(false);
	};

	/**
	 * Track users flight skills during free fly and give them feedback and mini tasks
	 */
	p.analyzeFly = function(elapsed)
	{
		if (_app.voPlayer.playing) return;

		var seedContainer = _panel.seedContainer;
		if (seedContainer.y > _screenTop.min &&
			seedContainer.y < _screenTop.max)
		{
			_screenTop.time += elapsed;
			// Daisy_Tutorial_L33 - Play if user is holding on screen and never letting go
			if (_screenTop.time >= _screenTop.warningTimeout)
			{
				// VO: Remember, let go of the screen and the seeds will fall down
				_app.voPlayer.play('Daisy_Tutorial_L33');
				_screenTop.time = 0;
				_currTaskTimer += _screenTop.penaltyAdditionalTime;
			}
		}
		else
		{
			_screenTop.time = 0;
		}

		if (seedContainer.y > _screenCenter.min &&
			seedContainer.y < _screenCenter.max)
		{
			_screenCenter.time += elapsed;
			// VO: Try flying to the top of the screen
			if (_screenCenter.time >= _screenCenter.warningTimeout)
			{
				_app.voPlayer.play('Daisy_Tutorial_L31');
				_screenCenter.time = 0;
				_currTaskTimer += _screenCenter.penaltyAdditionalTime;
			}
		}
		else
		{
			_screenCenter.time = 0;
		}
	};

	/**
	 * @method update
	 * @param {int} elapsed The frame update time in ms
	 * @return {Boolean} If this is enabled
	 */
	p.update = function(elapsed)
	{
		if (!_app.isTutorial) return false;

		switch (_task)
		{
			case Task.Fly:
				this.analyzeFly(elapsed);
				break;
		}

		if (_currTaskTimer && _currTaskTimer > 0)
		{
			_currTaskTimer -= elapsed;
			if (_currTaskTimer <= 0)
			{
				_currTaskTimer = null;
				// user failed to hit a wind gust, send them another gust
				// to attempt to hit...
				if (_task == Task.Breeze)
				{
					_task = Task.RepeatBreeze;
				}
				this.nextTask();
			}
		}
	};

	/**
	 * @param {springroll.Enum} task Set/Reset a task
	 */
	p.nextTask = function(setTask)
	{
		var isRepeat = false;
		// Check the curr task and choose the next task based on that
		if (setTask)
		{
			if (typeof setTask == 'string')
			{
				if (Task[setTask])
				{
					setTask = Task[setTask];
				}
				else
				{
					if (Debug) Debug.error('\'' + setTask + '\' is not a valid Task, choose:', Task);
				}
			}
			// Check if setTask is a repeat of the last task (still _task) before
			// assigning the setTask to _task
			if (_task && _task.name == setTask.name)
			{
				isRepeat = true;
			}
			_task = setTask;
		}
		else
		{
			switch (_task)
			{
				case Task.Fly:
					_task = Task.Leaves;
					break;
				case Task.Leaves:
					_task = Task.Breeze;
					break;
				case Task.Breeze:
					_task = Task.Powerups;
					break;
				case Task.Powerups:
					_task = Task.Complete;
					break;
				case Task.RepeatLeaves:
					isRepeat = true;
					_task = Task.Leaves;
					break;
				case Task.RepeatBreeze:
					isRepeat = true;
					_task = Task.Breeze;
					break;

			}
		}

		// If user is starting (or repeating) the task Fly
		if (_task == Task.Fly)
		{
			_currTaskTimer = _tutorialConfig.stableFlyTestTime;
			_screenCenter = _tutorialConfig.screenCenter;
			_screenCenter.time = 0;
			_screenTop = _tutorialConfig.screenTop;
			_screenTop.time = 0;
			_panel.seedContainer.on('heightWarning', this.onHeightWarning);
		}
		// If user is starting (or repeating) the task Leaves
		else if (_task == Task.Leaves)
		{
			var startLeaves = function()
			{
				_state.nextSegmentStart = _panel.camera.viewport.right;
				_state.spawnSegment(_tutorialConfig.leafSpawn);
				_panel.seedContainer.on('collide', this.onCollide);
				// If player can reach the end of this countdown without it being reset by a nextTask reset, then they have succeeded
				_currTaskTimer = APPRX_LEAF_SEGMENT_TIME;
			}.bind(this);
			if (isRepeat)
			{
				_currTaskTimer = APPRX_LEAF_SEGMENT_TIME;
				startLeaves();
			}
			else
			{
				_app.voPlayer.play([
					// VO: lookin' good!
					'Daisy_Tutorial_L35',
					// pause
					300,
					// VO: watch out for leaves bugs bird or you'll lose a seed
					startLeaves,
					'Daisy_Tutorial_L36'
				]);
			}
		}
		// If user is starting (or repeating) the task Breeze (aka breeze)
		else if (_task == Task.Breeze)
		{
			// And use endTutorial as a callback
			_panel.seedContainer.on('collide', this.onCollide);
			_currTaskTimer = APPRX_GUST_SEGMENT_TIME;
			// spawn (re-spawn) the gust
			_state.nextSegmentStart = _panel.camera.viewport.right;
			_state.spawnSegment(_tutorialConfig.gustSpawn);
			_app.voPlayer.play(isRepeat ?
				// VO: try to fly into some breezes
				'Daisy_Tutorial_L43' :
				// VO: breeze likes these give you a boost and make you invulnerable
				'Daisy_Tutorial_L42'
			);
		}

		else if (_task == Task.Powerups)
		{
			_currTaskTimer = null;
			// Tween the seeds back to center and auto fly them
			_state.nextSegmentStart = _panel.camera.viewport.right;
			_state.spawnSegment(_tutorialConfig.powerupsSpawn);
			_app.voPlayer.play([
				1000,
				// VO:  look for sparkly powerups like these
				'Daisy_Tutorial_L46',
				250,
				this.nextTask
			]);
		}

		else if (_task == Task.Complete)
		{
			_currTaskTimer = null;
			_app.voPlayer.play([
				1000,
				// VO: and that's it, you're ready to fly
				'Daisy_Tutorial_L50',
				1000
			], this.endTutorial);
		}
	};

	/**
	 * User has decided to skip the tutorial
	 * @method skip
	 */
	p.skip = function()
	{
		// Stop any VO and delayed calls
		_app.voPlayer.stop();
		_stopDelayedCalls();
		_arrow.show(false);

		_panel.breathMeter.off('paused', this.onMeterPaused);

		_skipButton.off('buttonPress', this.skip);
		_skipButton.visible = false;

		_app.isTutorial = false;
		_app.userData.write(COOKIE_NAME, true);

		// If we are the first phase where nature cat is still on the screen, return to normal gameplay (nature cat breathing in and out, etc.)
		if (_task == Task.WaitForTop || _task == Task.Breath)
		{
			var fadeOutsForInstruction = _app.config.tutorial.fadeOutsForInstruction;
			var sound = _app.sound;
			for (var i = 0, len = fadeOutsForInstruction.length; i < len; i++)
			{
				var item = fadeOutsForInstruction[i];
				var initVolume = sound._sounds[item.id].volume;
				sound.fadeIn(item.id, 1000, initVolume);
			}

			_panel.breathMeter.fullyEnable();

			_app.animator.getTimeline(_panel.natureCat).paused = false;

			if (app.sound.isPlaying('Anemometer'))
				_app.sound.resume('Anemometer');
			else
				_app.sound.play('Anemometer');

			if (app.sound.isPlaying('WindSockBlowing'))
				_app.sound.resume('WindSockBlowing');
			else
				_app.sound.play('WindSockBlowing');
		}
		//if the tutorial is past the point where it has scrolled at all, we need to reset the state completely to return to NatureCat
		else
		{
			this.endTutorial();
		}
	};

	/**
	 * Tutorial collision handling
	 * @method onCollide
	 */
	p.onCollide = function(floater)
	{
		_panel.seedContainer.off('collide', this.onCollide);
		if (_task == Task.Leaves)
		{
			_task = Task.RepeatLeaves;
			_app.voPlayer.play(_collideVOList.random());
		}
		else if (_task == Task.Breeze)
		{
			_currTaskTimer = null;
			// The breeze VO might not finish if player hits the breeze quickly,
			// so lets ensure that it finishes before the final plays
			if (_app.voPlayer.playing)
			{
				_app.voPlayer._callback = this.nextTask;
			}
			else
			{
				this.nextTask();
			}
		}
	};

	/**
	 * The tutorial has ended or was skipped
	 * @method endTutorial
	 */
	p.endTutorial = function()
	{
		_panel.breathMeter.off('paused', this.onMeterPaused);
		_panel.seedContainer.off('collide', this.onCollide);
		_panel.seedContainer.off('heightWarning', this.onHeightWarning);
		if (_skipButton)
		{
			_skipButton.off('buttonPress', this.skip);
		}
		// Potential destroy group
		var destroyables = [
			_groundWarningIconDC,
			_clickNatureCatDC,
			_arrow,
			_groundWarningIcon,
		];
		for (var i = 0, len = destroyables.length; i < len; i++)
		{

			var d = destroyables[i];
			if (d)
			{
				if (d.parent) d.parent.removeChild(d);
				if (d.destroy) d.destroy();
			}
		}
		destroyables = null;

		// No more tutorial cookie save
		_app.userData.write(COOKIE_NAME, true);
		_app.isTutorial = false;
		DebugOptions.tutorial = null;
		// Hide the skip button and clear the HUD
		_skipButton.visible = false;
		_panel.hud.show(false);

		_groundWarningIconDC = null;
		_app = null;
		_arrow = null;
		_currTaskTimer = null;
		_groundWarningIcon = null;
		_panel = null;
		_screenCenter = null;
		_skipButton = null;
		_task = null;
		_tutorialConfig = null;

		// Refresh the state to trigger all cleanup
		_state.manager.refresh();
		_state = null;
	};

	// Assign to namespace
	namespace('nature').Tutorial = Tutorial;
}());